export const DOCUMENT_GENERATION_ACCESS_TOKEN_COOKIE_NAME =
  "document-generation-user-access-token";
export const DOCUMENT_GENERATION_REFRESH_TOKEN_COOKIE_NAME =
  "document-generation-user-refresh-token";

// set once the page is drawn, by the documents' parent page (website `pages/documents/index.vue`)
export const DOCUMENT_READY_ATTRIBUTE = "data-document-ready";
export const DOCUMENT_READY_SELECTOR = `[${DOCUMENT_READY_ATTRIBUTE}]`;
